//https://www.youtube.com/watch?v=2YB0oC3Yt4M

export abstract class AppConfiguration{
    urlInformation: string;
    urlClientInformation: string;
    userName: string;
    pass: string;
    fleetuserid: string;
    conncode: string;
    polarixapiuser: string;
    polarixapipass: string;
    apiBaseUrlUtility: string;
}